export const fallbackErrorMessage =
    "We’re sorry but we were unable to process your payment. Please try again.";